export const updateIntegration = ({ token, id, body }) => ({
  HTTPMethod: "put",
  path: `/api/v1/conduit/integrations/${encodeURIComponent(id)}`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body,
});
